declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

type SignupMethod = 'email' | 'google' | 'microsoft';

export const pushSignupEvent = (signupMethod: SignupMethod): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'sign_up',
    signup_method: signupMethod,
  });
};
